import swal from "sweetalert";
import * as countries from "@/constants/countries";
import CircleService from "../../../services/circle";
import AuthService from "../../../services/auth";
const PhoneNumber = require("awesome-phonenumber");
import router from '../../../router';

const circleService = new CircleService();
const authService = new AuthService();

export default {
  name: "AddToCovid19Tracker",
  props: ["tracker", "profile"],
  data() {
    return {
      formNo: 0,
      latLng: { lat: 9.0748812, lng: 7.465183 },
      mapOptions: {
        zoom: 5,
        scrollWheel: false,
        zoomControl: true,
        disableDefaultUI: true,
        scaleControl: false,
        rotateControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeId: this.$props.type || "terrain"
      },
      countries: countries.data,
      selectedCountryCode: countries.data.find(
        country => country.name.toLowerCase() === "nigeria"
      ).dial_code,
      formData: {},
      tagsData: {},
      errorNote: null,
      fullPhone: "",
      phoneValid: false,
      title: "",
      description: "",
      isSubmitting: false
    };
  },
  computed: {
    profileValid: function () {

      if (!this.profile.name || this.profile.name === '') { return false };
      if (!this.profile.email || this.profile.email === '') { return false };
      if (!this.fullPhone || this.fullPhone === '') { return false };
      if (!this.title || this.title === '') { return false };
      if (!this.description || this.description === '') { return false };

      return true;
    }
  },
  watch: {
    "$props.tracker": {
      handler: function (val) {
        // clear form when diff modal opens
        this.formNo = 0;
        this.formData = {};
        this.errorNote = null;
        this.latLng = { lat: 9.0748812, lng: 7.465183 };
      },
      immediate: true,
      deep: true
    },
    selectedCountryCode: {
      handler: function (val) {
        if (!this.profile) {
          return;
        }
        this.selectedCountry = this.countries.find(
          country => country.dial_code === val
        );
        const phone = new PhoneNumber(
          this.profile.phone,
          this.selectedCountry.code
        ).a;
        if (phone.possibility !== "unknown") {
          this.fullPhone = phone.number["e164"];
          this.phoneValid = phone.valid;
        }
      },
      immediate: true,
      deep: true
    },
    "profile.phone": {
      handler: function (val) {
        const phone = new PhoneNumber(val, this.selectedCountry.code).a;
        if (phone.possibility !== "unknown") {
          this.fullPhone = phone.number["e164"];
          this.phoneValid = phone.valid;
        }
      },
    }
  },
  methods: {
    done() {
      this.isSubmitting = true;
      const form = new FormData();
      form.append("circle_id", this.tracker.circle._id);

      // TODO: validation
      form.append("name", this.profile.name);
      form.append("email", this.profile.email);
      form.append("phone", this.fullPhone);
      form.append("title", this.title);
      form.append("description", this.description);

      form.append("upload_id", this.profile.upload_id);
      form.append("status", this.profile.status);
      form.append("latitude", this.latLng.lat);
      form.append("longitude", this.latLng.lng);
      for (var i in this.formData) {
        form.append("identity_id[]", i);
        form.append("identity_value[]", this.formData[i]);
      }

      const closeBtn = document.getElementById("dismissBtnAddEditPostToMap");
      circleService
        .submitCovid19Tracker(form)
        .then(res => {
          this.$root.$emit("ShowSuccessNotification", res.data.message);
          this.isSubmitting = false;
          closeBtn.click();
          swal({
            text:
              "Information has been submitted.",
            icon: "success",
            buttons: "Okay"
          }).then(answer => {
            if (res.data.token) {
              authService.setSession({
                token: res.data.token,
                user: res.data.profile
              }, 'default', '/howfar')
            } else {
              router.replace({ path: '/howfar' })
            }
          });
        })
        .catch(err => {
          // console.log(err)
          this.$root.$emit("ShowErrorNotification", err.message);
          this.isSubmitting = false;
        });
    },
    next() {
      const closeBtn = document.getElementById("dismissBtnAddEditPostToMap");

      if (!this.tracker.identities) {
        this.formNo = 1;
      }

      if (
        Object.keys(this.formData).length !== this.tracker.identities.length
      ) {
        this.errorNote = "Complete the form to continue";
        return;
      }

      const errors = [];

      for (var id in this.formData) {
        if (this.formData[id] === "") {
          const found = this.tracker.identities.find(
            identity => identity._id == id
          );
          errors.push(found);
        }
      }
      if (errors.length) {
        this.errorNote = "Some fields are blank";
        return;
      }
      this.errorNote = null;
      this.formNo = 1;
      return;
    },
    markerCallback(e) {
      this.latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.mapOptions.zoom = 13;
        this.latLng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    inspectTagChange(e, id) {
      if (e.target.value === 'Other') {
        this.formData[id] = ''
        this.tagsData[id] = 'Other'
      }
      this.formData[id] = e.target.value
    }
  },
  mounted() {
    this.geolocate()
  }
}
